import { MENU_BIG, MENU_SMALL } from '@constants/menu.contant';
import { SEARCH_CONTAINER_HEIGHT } from '@features/customers/constants/search.constants';
import { makeStyles } from '@mui/styles';

const useUsersStyles = makeStyles({
	headerContainer: {
		alignItems: 'center',
		backgroundColor: 'white',
		boxShadow: '0px 3px 6px #0000000D',
		display: 'flex',
		height: SEARCH_CONTAINER_HEIGHT,
		justifyContent: 'center',
		padding: `8px 0`,
		position: 'fixed',
		zIndex: 1200,
	},
	headerContainerBig: {
		width: `calc(100% - ${MENU_BIG})`,
	},
	headerContainerSmall: {
		width: `calc(100% - ${MENU_SMALL})`,
	},
	notFoundImg: {
		width: '326px',
		height: '293px',
	},
	elementContainer: {
		marginTop: '70px',
		marginLeft: '40px',
		marginRight: '40px',
	},

	container: {
		height: '90vh',
		backgroundColor: 'white',
		borderRadius: '0px 25px 0px 0px',
	},

	separador: {
		opacity: 1,
		height: '4px',
		width: '210px',
		marginTop: '-8px',
		marginLeft: '25px',
		borderRadius: '10px 10px 0px 0px',
		background: '#1063AC 0% 0% no-repeat padding-box',
	},

	tab: {
		top: '68px',
		left: '115px',
		width: '260px',
		height: '50px',
		cursor: 'pointer',
		alignItems: 'center',
		alignContent: 'center',
		display: 'inline-block',
		backgroundColor: '#FFFFFF',
		borderRadius: '25px 25px 0px 0px',
		'& p': {
			opacity: 1,
			fontSize: '16px',
			color: '#1063AC',
			fontWeight: '800',
			fontFamily: 'Montserrat',
		},
	},
	containerNotFound: {
		width: 715,
		margin: 'auto',
		textAlign: 'center',
		marginTop: 158,
	},
	notFoundTitle: {
		color: '#003C82',
		fontSize: '28px',
		fontFamily: 'Montserrat',
		fontWeight: '700',
		marginTop: '40px',
		marginBottom: '10px',
	},
	p: {
		color: '#00000099',
		fontSize: '16px',
		fontFamily: 'Montserrat',
		fontWeight: 500,
		margin: 0,
		'& strong': {
			color: '#003C82',
			fontWeight: '700',
		},
	},
});

export default useUsersStyles;
